// @codekit-prepend "extern/jquery.justifiedGallery.js"
// @codekit-prepend "extern/jquery.fancybox.js"
// @codekit-prepend "extern/swiper-min.js"

jQuery(document).ready(function ($) {
  if (window.innerWidth > 600) {
    new WOW().init();
  }

  /**
   *
   * Navigation
   */
  $(".link-solutions, .nav-desktop-content .drop-menu").on({
    mouseenter: function () {
      $(".nav-desktop-content .drop-menu").show();
    },
    mouseleave: function () {
      $(".nav-desktop-content .drop-menu").hide();
    },
  });

  /**
   * Counter
   */
  const counters = $(".counter");
  const counters_loop = [];
  let counter_loop = 0;
  let counter_started = false;
  for (let i = 0; i < counters.length; i++) {
    const loop = [];
    loop.counter = $("span", counters[i]).text();
    loop.start = loop.counter - 6;
    $("span", counters[i]).text(loop.start);
    counters_loop[i] = loop;
  }
  $(window).scroll(function () {
    if ($(".counters").length) {
      const scroll = $(window).scrollTop();
      if (scroll >= $(".counters").offset().top - $(window).height()) {
        if (!counter_started) {
          startCounters();
        }
      }
    }
  });
  function startCounters() {
    counter_started = true;
    const count_interval = setInterval(function () {
      counter_loop++;
      for (let i = 0; i < counters.length; i++) {
        const loop = counters_loop[i];
        loop.start++;
        $("span", counters[i]).text(loop.start);
      }
      if (counter_loop > 5) {
        clearInterval(count_interval);
      }
    }, 200);
  }

  $(window).scroll(function () {
    const scroll = $(window).scrollTop();
    if (scroll > 100) {
      $(".nav-primary").addClass("nav-transpoarent");
      // if (!$('body').hassClass('page-template-sections-blue')) {
      $(".front-logo img").attr("src", "/wp-content/themes/expl-theme/assets/img/introlution-logo.svg");
      // }
    } else {
      $(".nav-primary").removeClass("nav-transpoarent");
      $(".front-logo img").attr("src", "/wp-content/themes/expl-theme/assets/img/introlution-logo-white.svg");
    }
  });

  // CLICK FUNCTIES +++++++++++++++++++++++++++ //

  // Hamburger toggle -----------
  $(".hamburger").on("click", function () {
    $(this).toggleClass("actief");
    $(".nav-mobile-menu").toggleClass("actief");
  });

  // Algemene toggle -----------
  $(".toggle").on("click", function () {
    $(this).toggleClass("actief");
  });

  // Actieveren popup -----------
  $(".poptrig").on("click", function () {
    $(".popup").addClass("toon");
    $("body").addClass("noscroll");
  });
  $(".inner .sluiten ,body").on("click", function () {
    $(".popup").removeClass("toon");
    $("body").removeClass("noscroll");
  });
  $(".poptrig,.popup .inner").click(function (e) {
    e.stopPropagation();
  });

  // COOKIES ++++++++++++++++++++++++++ //

  // melding-popup
  $(".melding-popup .sluiten").click(function () {
    $(".melding-popup").addClass("hidden");
    Cookies.set("melding-popup.hide", "true", { expires: 7 });
  });
  if (Cookies.get("melding-popup.hide")) {
    $(".melding-popup").addClass("keep-hidden");
  }

  // melding-boven
  $(".melding-boven .sluiten").click(function () {
    $(".melding-boven").addClass("hidden");
    Cookies.set("melding-boven.hide", "true", { element: ".melding-boven" }, { expires: 7 });
  });
  if (Cookies.get("melding-boven.hide")) {
    $(".melding-boven").addClass("keep-hidden");
  }

  // SCROLL FUNCTIES ++++++++++++++++++++++++++ //

  // Back to top -----------
  $(".backtotop").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });

  $(window).scroll(function () {
    if ($(window).scrollTop() > 400) {
      $(".backtotop").addClass("toon");
    } else if ($(window).scrollTop() <= 400) {
      $(".backtotop").removeClass("toon");
    }
    if ($(window).scrollTop() + $(window).height() === $(document).height()) {
      $(".backtotop").addClass("fix");
    } else {
      $(".backtotop").removeClass("fix");
    }
  });

  // VASTE VENDORS +++++++++++++++++++++++++++ //

  // Toewijzen justified gallery -----------
  if ($(".acf-justigal")[0]) {
    $(".acf-justigal").justifiedGallery();
  }

  // CUSTOM SCRIPTS KOMEN HIER ONDER --------------------------------------------------------------------------//
  // -----------------------------------------------------------------------------------------------------------//

  // SLICK
  if ($(".slick-slider").length > 0) {
    if ($(".slick-slider .slider-item").length <= 4) {
      $(".slick-slider-controls .carousel-control-prev, .slick-slider-controls .carousel-control-next").hide();
      $(".slick-slider .slider-item").addClass("col-lg-6 col-xl-3");
    } else {
      $(".slick-slider").slick({
        slidesToShow: 4,
        infinite: false,
        prevArrow: $(".slick-slider-controls .carousel-control-prev"),
        nextArrow: $(".slick-slider-controls .carousel-control-next"),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }
  }
  if ($(".slick-slider-testimonials").length > 0) {
    $(".slick-slider-testimonials").slick({
      slidesToShow: 1,
      infinite: false,
      prevArrow: $(".slick-slider-testimonials-controls .carousel-control-prev"),
      nextArrow: $(".slick-slider-testimonials-controls .carousel-control-next"),
    });
  }
  if ($(".photo-slider").length > 0) {
    if ($(".photo-slider .photo-slide").length === 1) {
      $(".photo-slider-controls-container").hide();
    }
    $(".photo-slider").slick({
      slidesToShow: 1,
      infinite: false,
      prevArrow: $(".photo-slider-controls .carousel-control-prev"),
      nextArrow: $(".photo-slider-controls .carousel-control-next"),
    });
  }

  if ($(".photo-slider-simple").length > 0) {
    if ($(".photo-slider .photo-slide").length === 1) {
      $(".photo-slider-controls-container").hide();
    }
    $(".photo-slider-simple").slick({
      adaptiveHeight: true,
      slidesToShow: 1,
      infinite: false,
      prevArrow: $(".photo-slider-simple-controls .carousel-control-prev"),
      nextArrow: $(".photo-slider-simple-controls .carousel-control-next"),
    });
  }
});
